// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-56a2c738]{position:relative}.items-container[data-v-56a2c738]{border-bottom:1px solid;border-top:1px solid;margin-top:1rem;padding-bottom:1.5rem}.items-container .item[data-v-56a2c738]{margin-top:1.5rem}.items-container .item .title[data-v-56a2c738]{line-height:1;margin-top:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
